import baseConfig from '@config/baseConfig';

const phaserConfig = baseConfig();

const audio = {
  bgaudio: null,
  heliaudio: null,
  hintaudio: null,
  incorrectdropaudio: null,
  correctdropaudio: null,
  yayaudio: null,
};
for (let i = 1; i <= 10; i++) audio['qa' + i] = null;
for (let i = 1; i <= 4; i++) audio['ta' + i] = null;

export const config = {
  width: phaserConfig.width,
  height: phaserConfig.height,
  audio,
};

export const gameState = {
  score: 0,
  attempted: 1,
  questionNumber: 0,
  hints: 0,
  gameWin: false,
};
